(function() {
  const baseScrollSpeed = 1;
  const scrollInterval = 60;
  const desktopBreakpoint = 768;

  function isDesktop() {
    return window.innerWidth > desktopBreakpoint;
  }

  function isHomepage() {
    return document.body.classList.contains('template-index');
  }

  function shouldScroll() {
    return !(isHomepage() && isDesktop()); 
  }

  function getScrollSpeed() {
    return window.innerWidth > 1920 ? baseScrollSpeed * 2 : baseScrollSpeed;
  }

  function autoScroll(carousel) {
    if (!shouldScroll()) return; 

    const scrollSpeed = getScrollSpeed();
    setInterval(() => {
      if (carousel.scrollLeft + carousel.clientWidth < carousel.scrollWidth) {
        carousel.scrollLeft += scrollSpeed;
      } else {
        carousel.scrollLeft = 0;
      }
    }, scrollInterval);
  }

  document.addEventListener('DOMContentLoaded', () => {
    const carousels = document.querySelectorAll('.scrollable-line');
    
    carousels.forEach(carousel => {
      const originalContent = carousel.innerHTML;
      
      if (!isHomepage() || !isDesktop()) {
        carousel.innerHTML = originalContent + originalContent;
        autoScroll(carousel); 
      }
    });

    // Handle resize events
    window.addEventListener('resize', () => {
      if (isHomepage() && isDesktop()) {
        carousels.forEach(carousel => {
          carousel.scrollLeft = 0; 
        });
      }
    });
  });
})();